import * as React from 'react';
import GamePageLayout from '../../../components/GamePageLayout';
import {Button , showLoading,showErrorDialog , showCustomDialog , closeDialog, Util} from "baziigram";
import './styles.css'
import GameNavbar from "../../../components/GameNavbar";
import GameHeader from "../../../components/GameHeader";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../../../redux/actions";
import {OFFER_WALL_ACTION_PERSIST , OFFER_WALL_ACTION_CLEAR} from "../../../redux/OfferWall/offerwall.constant.js"
import {navigate} from "gatsby-link";
import * as Adivery from 'adivery-js';
import appService from '../../../Service'
import  {STORAGE_KEY,dictionary} from "../../../constants";
import {UpdateUser , GetUser} from "../../../Util/user"
import {showRewardedAd} from "../../../Util/Ads"

const OfferWallPage = (props) => {

const { levelInfo , user , alternatives , language ,gameId , className } = useSelector(state => state.offerwall);


const dispatch = useDispatch();
  const updateState=(state)=>{
    dispatch(persist(state, OFFER_WALL_ACTION_PERSIST))

  }

var gameanalytics = typeof window !== `undefined`? require('gameanalytics'):null;
Adivery.configure("e0ad1434-2225-4b17-8fb2-67ae6018ed7d");

 React.useEffect(()=>{
           let l = Util.getLanguage()
           updateState({language:l , className:l=="fa"?"rtl text-right" : "ltr text-left",
           user:GetUser()})
          },[])

 React.useEffect(()=>{
   if(props.location.state && props.location.state.gameId)
     updateState({gameId:props.location.state.gameId ,
      alternatives:props.location.state.alternatives,
      levelInfo:props.location.state.levelInfo})

    },[])


    const scrollToOffers = ()=>{
        document.getElementById('offers').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

const goToLink=(item)=>{
    if(item.type == "game"){
    if(typeof window !== `undefined`) {
      let game = levelInfo.link.split("?gameId=")[1].split("&")[0]
      gameanalytics.GameAnalytics.addProgressionEvent(gameanalytics.EGAProgressionStatus.Start,
          game, null, null, user);
    }
    navigate("/WebView",{state:{url:item.link}})
    }
    else if(item.type=="insta")
    window.open(item.link)

    else if(item.type=="videoAd")
        showRewardedAd(addCoin,gameId)
  }



const addCoin=()=>{
showLoading(true)
appService.GameAlternativeLog(3,0,gameId).then(res=>{
if(res.user)
UpdateUser(res.user)
showReceivedCoinDialog(res)
}).catch(err=>{
showErrorDialog(err.message || err)
}).finally(res=>{showLoading(false)})
}

const showReceivedCoinDialog=(result)=>{
let body = <div style={{lineHeight:"30px"}} className={'d-flex flex-column align-items-center justify-content-between'}>
      <div className={"d-flex flex-row justify-content-between w-100"}>
        <button
            type="button"
            className="close"
            onClick={closeDialog}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <img className="mx-auto" src={"/images/icons/coin2.png"} width={"60px"}/>
      <div className={"my-2 text-warning"} style={{fontWeight:"bold",fontSize:"1.2rem"}}> {result.coin} {dictionary.phoecoin[language]}  </div>
      <div className={`${className} text-center`}>{result.message}</div>
      <Button onClick={()=>{closeDialog();navigate("/Store",{state:{gameId}})}} title={dictionary.goToStore[language]}></Button>
    </div>

    showCustomDialog(body)

}
    return (
        <GamePageLayout type={OFFER_WALL_ACTION_CLEAR}>
            <GameNavbar backUrl={"/Game/LifeStone"}/>
            <div className={"rtl"}>
                <GameHeader headerImage={"/images/main-page/merlin.png"}>

                 {levelInfo &&
                        <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                          <div dangerouslySetInnerHTML={{__html:dictionary.offerwallHeader[0][language]}}/>
                             <span className="text-warning mx-1"> «{levelInfo.achievement.name}» </span>
                              {dictionary.offerwallHeader[1][language]}
                              {user.levelInfo.level}
                               {dictionary.offerwallHeader[2][language]}
                               {dictionary.offerwallHeader[3][language]}

                            <Button className={"mt-3"} onClick={scrollToOffers} title={dictionary.seeItems[language]}></Button>

                        </div>
                    }

                </GameHeader>





                <div id={"offers"} className='main-container'>
                    {/* <div className="main_container"> */}

                     <>
                        <div className="grid-container rtl ">
                            <div
                                className={`wall-container row align-items-start justify-content-center`}
                                style={{ rowGap: '50px', paddingTop: '50px' }}
                            >
                                {
                                    alternatives && alternatives.map(item=>{
                                        return <div   className=" col-12 col-lg-3 p-0  my-4">
                                               <div className={"offerItem d-flex flex-column align-items-center justify-content-center"}>
                                                  <img alt="suggestion" className={"offerItemLogo"}  src={item.logo} width={"120px"}/>
                                                  <div className={" d-flex flex-row w-100 align-items-center justify-content-between"}>
                                                   <div className={"text-center my-2 mr-2"}>{item.title}</div>

                                                   <div className={`d-flex  flex-row align-items-center justify-content-end ${className}`}>
                                                       <div className={"text-center my-2"}>{item.coins}</div>
                                                       <img alt="coin" className="mr-2" src={"/images/icons/coin2.png"} width={"22px"}/>
                                                    </div>
                                                    </div>
                                                    <div className={className}>{item.description}</div>
                                                 <Button onClick={()=>goToLink(item)} className={"buyButton"} title={dictionary.LetsGo[language]} />
                                               </div>

                                        </div>
                                    })
                                }

                            </div>

                        </div>
                    </>



                </div>


            </div>

        </GamePageLayout>
    )
}

export default OfferWallPage;
